import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../Button';
import PiwikButton from '../PiwikButton';
var StyledLink = styled(Link).withConfig({
  componentId: "sc-12ala9g-0"
})(["&,&:hover,&:focus,&:active{text-decoration:none;}"]);
/**
 * `LinkButton` wraps a `Button` (or `PiwikButton`) in a [NavLink](#navlink).
 *
 * @public
 * @author Connor Taylor
 */

var LinkButton =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(LinkButton, _Component);

  function LinkButton() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = LinkButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        to = _this$props.to,
        onClick = _this$props.onClick,
        logEvent = _this$props.logEvent,
        rest = _objectWithoutPropertiesLoose(_this$props, ["to", "onClick", "logEvent"]);

    var ButtonComponent = logEvent ? PiwikButton : Button;
    return React.createElement(StyledLink, {
      to: to,
      onClick: onClick
    }, React.createElement(ButtonComponent, rest, this.props.children));
  };

  return LinkButton;
}(Component);

LinkButton.defaultProps = {
  to: "/"
};
export default LinkButton;